import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "../../style/Home.css";
import Logo from "../../images/logo.svg";
import axios from "axios";
import Acuite from "../../images/acuite.png";
import { useEffect } from "react";
import Dalle from "../Dalle";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { logOut } from "../../utils/login";

import ModalAvertissement from "./ModalAvertissement";

import { useToasts } from "react-toast-notifications";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBView,
  MDBCardImage,
} from "mdbreact";

const API_URL = process.env.REACT_APP_API_URL;

function Home() {
  const [show, setShow] = useState(false);
  const [fournisseurs, setFournisseurs] = useState();
  const [verriers, setVerriers] = useState();
  const [lentilles, setLentilles] = useState();
  const [mutuelles, setMutuelles] = useState();
  const position = 1;
  const [type, setType] = useState("2");
  const [entite_Id, setEntite_Id] = useState();
  const [url, setUrl] = useState();
  const [nom, setNom] = useState();
  const [dalles, setDalles] = useState();
  const [refresh, setRefresh] = useState(false);
  const [showAvertissement, setShowAvertissement] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const loggedIn = useSelector((state) => state.login);
  const { addToast } = useToasts();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowAvertissement = () => setShowAvertissement(true);

  // Redirect unauthenticated users to the login page
  useEffect(() => {
    if (!loggedIn && history.location.pathname !== "/login") {
      history.push("/login");
    }
  }, [loggedIn, history]);

  function handleSubmit() {
    axios
      .put(
        `${API_URL}/api/dalles/`,
        { type, entite_Id, url, nom, position },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        addToast("Dalle ajoutée !", {
          appearance: "success",
          autoDismiss: true,
        });
        setRefresh(!refresh);
      })
      .catch((e) => {
        if (e.response.status === 401) {
          addToast("Votre session est expirée. Merci de vous reconnecter.", {
            appearance: "warning",
            autoDismiss: true,
          });
          logOut();
          dispatch({ type: "LOGOUT" });
          history.push("/login");
        } else {
          addToast(`Erreur : ${e.message}`, {
            appearance: "error",
            autoDismiss: true,
          });
        }
      });
  }

  useEffect(() => {
    function getHomeInfo() {
      axios
        .all([
          axios.get(`${API_URL}/api/fournisseurs`),
          axios.get(`${API_URL}/api/verriers`),
          axios.get(`${API_URL}/api/lentilles`),
          axios.get(`${API_URL}/api/mutuelles`),
          loggedIn
            ? axios.get(`${API_URL}/api/dalles`, {
                headers: {
                  authorization: `Bearer ${token}`,
                },
              })
            : null,
        ])
        .then((res) => {
          setFournisseurs(res[0].data);
          setVerriers(res[1].data);
          setLentilles(res[2].data);
          setMutuelles(res[3].data);
          if (loggedIn) {
            setDalles(res[4].data);
          }
        })
        .catch((e) => {
          if (e.response.status === 401) {
            addToast("Votre session est expirée. Merci de vous reconnecter.", {
              appearance: "warning",
              autoDismiss: true,
            });
            logOut();
            dispatch({ type: "LOGOUT" });
            history.push("/login");
          } else {
            addToast(`Erreur : ${e.message}`, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    }
    getHomeInfo();
  }, [refresh]);

  return (
    <div className="homeMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Lemonocle.net : annuaire pour les opticiens</title>
      </Helmet>
      <img src={Logo} alt="Logo monocle" className="homeLogo" />
      {/* <span className='searchBar'>
                <form action="https://www.google.com/search" method="get">
                    <img src={googleLogo} alt="Logo Google" className="googleLogo" />
                    <input type="search" name="q" className="homeSearchInput" />
                    <MDBBtn outline color="elegant" type="submit">Recherche Google</MDBBtn>
                </form>
            </span> */}
      <div className="homeTilesContainer">
        <a
          href="http://www.acuite.fr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <MDBCard className="homeTile greenBackground">
            <MDBView className="greenBackground">
              <MDBCardImage
                className="img-fluid"
                src={Acuite}
                alt="logo acuité"
              />
            </MDBView>
          </MDBCard>
        </a>
        {dalles &&
          dalles.map((dalle) => (
            <Dalle
              id={dalle.id}
              key={dalle.id}
              type={dalle.type}
              entite={dalle.entite_id}
              url={dalle.url}
              nom={dalle.nom}
              refresh={refresh}
              setRefresh={setRefresh}
            />
          ))}
        <button
          type="button"
          className="addTileButton"
          onClick={loggedIn ? handleShow : handleShowAvertissement}
        >
          +
        </button>
      </div>
      <MDBContainer>
        <MDBModal isOpen={show} toggle={handleClose}>
          <MDBModalHeader>Ajouter une dalle sur l'accueil</MDBModalHeader>
          <MDBModalBody>
            <div className="modalAddTile">
              <span>
                {" "}
                Type de dalle:
                <select onChange={(e) => setType(e.target.value)}>
                  <option value="2">Fournisseur montures</option>
                  <option value="3">Fournisseur lentilles</option>
                  <option value="4">Mutuelle</option>
                  <option value="1">Verrier</option>
                  <option value="5">Lien personnalisé</option>
                </select>
              </span>
              <br />
              <span>
                {type === "1" && "Choisissez le verrier"}
                {type === "2" && "Choisissez le fournisseur"}
                {type === "3" && "Choisissez le fournisseur lentilles"}
                {type === "4" && "Choisissez la mutuelle"}

                {type !== "5" && (
                  <select onChange={(e) => setEntite_Id(e.target.value)}>
                    <option value="">--Choisissez un contact--</option>
                    {type === "2" && fournisseurs
                      ? fournisseurs.map((a) => (
                          <option value={a.id} key={a.id}>
                            {a.nom}{" "}
                          </option>
                        ))
                      : "loading"}
                    {type === "1" && verriers
                      ? verriers.map((a) => (
                          <option value={a.id} key={a.id}>
                            {a.nom}{" "}
                          </option>
                        ))
                      : "loading"}
                    {type === "3" && lentilles
                      ? lentilles.map((a) => (
                          <option value={a.id} key={a.id}>
                            {a.nom}{" "}
                          </option>
                        ))
                      : "loading"}
                    {type === "4" && mutuelles
                      ? mutuelles.map((a) => (
                          <option value={a.id} key={a.id}>
                            {a.nom}{" "}
                          </option>
                        ))
                      : "loading"}
                  </select>
                )}
              </span>
              <span>
                {type === "5" && "Titre de la dalle : "}
                {type === "5" && (
                  <input
                    type="text"
                    placeholder="Titre de la dalle"
                    onChange={(e) => setNom(e.target.value)}
                  />
                )}
              </span>
              <br />
              <span>
                {type === "5" && "Adresse : "}
                {type === "5" && (
                  <input
                    type="url"
                    placeholder="https://exemple.com"
                    onChange={(e) => setUrl(e.target.value)}
                  />
                )}
              </span>
            </div>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" outline color="primary" onClick={handleClose}>
              Fermer
            </MDBBtn>
            <MDBBtn
              type="button"
              color="primary"
              onClick={() => {
                handleSubmit();
                handleClose();
              }}
            >
              Ajouter
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
      <ModalAvertissement
        showAvertissement={showAvertissement}
        setShowAvertissement={setShowAvertissement}
      />
    </div>
  );
}

export default Home;
